import { Suspense, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '@wojtekmaj/react-t';
import { QrCodeIcon } from 'lucide-react';

import colors from '@rewardopl/styles/colors';

import Dialog from '@rewardopl/react-ui/dialog';

import { Button, Wrapper } from './your_code_button.styles';

import DynamicCode from '../../common/dynamic_code';

export default function YourCodeButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const yourCodeString = useTranslation('Your code');

  function openDialog() {
    navigate('#your-code', {
      state: {
        ...(location.state as Record<string, unknown>),
        scrollToTop: false,
      },
    });
  }

  const closeDialog = useCallback(() => {
    navigate(
      {
        ...location,
        hash: '',
      },
      { state: location.state },
    );
  }, [location, navigate]);

  return (
    <>
      <Button onClick={openDialog} title={yourCodeString} type="button">
        <QrCodeIcon size={32} />
      </Button>
      <Dialog isOpen={location.hash === '#your-code'} onDismiss={closeDialog} title="Your code">
        <Wrapper>
          <Suspense fallback={null}>
            <DynamicCode color={colors.black} />
          </Suspense>
        </Wrapper>
      </Dialog>
    </>
  );
}
